<nav class="navbar navbar-transparent navbar-color-on-scroll fixed-top navbar-expand-lg" color-on-scroll="100" id="sectionsNav">
  <div class="container">
    <div class="navbar-translate">
      <a class="navbar-brand" href="https://skilledminds.com.ng" rel="tooltip"
         title="Coded by Iruobe Akhigbe" data-placement="bottom" target="_blank">
        <div class="diff">
          <span>College</span>Dreams
        </div>
      </a>
      <button class="navbar-toggler" type="button" data-toggle="collapse" aria-expanded="false" aria-label="Toggle navigation">
        <span class="sr-only">Toggle navigation</span>
        <span class="navbar-toggler-icon"></span>
        <span class="navbar-toggler-icon"></span>
        <span class="navbar-toggler-icon"></span>
      </button>
    </div>
    <div class="collapse navbar-collapse">
      <ul class="navbar-nav ml-auto">
        <li class="nav-item">
          <a class="nav-link" href="javascript:void(0)" (click)="scrollToAbout()">
            <i class="now-ui-icons clothes_tie-bow"></i>
            <p class="nav-menus">ABOUT</p>
          </a>
        </li>
        <li class="nav-item">
          <a href="#" class="nav-link">
            <i class="now-ui-icons design_vector"></i>
            <p class="nav-menus">FEATURES</p>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="javascript:void(0)" (click)="scrollToContact()">
            <i class="now-ui-icons ui-1_email-85"></i>
            <p class="nav-menus">Contact</p>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link loginbutton" [routerLink]="['/login']">
            <i class="now-ui-icons arrows-1_share-66"></i>
            <p class="">&nbsp;LOGIN</p>
          </a>
        </li>
      </ul>
    </div>
  </div>
</nav>
<!--<div (click)="scrollToTop()" class="scroll-to-top" *ngIf="pageYoffset > 0" >
    <div class="mouse-wheel">
      <i class="fa fa-chevron-up"></i>
    </div>
</div>-->

<div class="page-header header-filter" data-parallax="true" style="background-image:
url('../../.././assets/img/collegedreams.jpg'); height: 983px">
  <div class="container" style="margin-top: 32%;">
    <div class="row">
      <div class="col-md-6">
        <h1 class="title">A <span class="span2">Complete</span> enterprise
          solution for all schools.</h1>
        <h4>Designed to automate all school processes from admission to result collation, e-payment with <span
          class="span2"><i>epurse</i></span>, bulk sms, email notification to parents, elearning, online result checker,
          and lots
          more...</h4>
        <br>
        <a [routerLink]="['/sign-up']" class="signup-button">
          <span style="color: #FFFFFF"> Sign Up </span>
        </a> &nbsp;
        <a href="#" class="">
          <span class="demo-button">
            <i class="fa fa-play"></i>
          </span>
          <span style="color: #FFFFFF"> See Demo</span>
        </a>
      </div>
    </div>
  </div>
</div>
<div class="main section-story-overview">
  <div class="container">
    <div class="section text-center">
      <div class="row">
        <div class="col-md-8 ml-auto mr-auto">
          <!--<h2 class="title">Let&apos;s talk product</h2>-->
          <h2 class="title">All-in-one <span class="span2">Solution</span></h2>
          <h5 class="description">
            CollegeDreams is one powerful software that contains all the tools <br> needed to run a successful school.
          </h5>
        </div>
      </div>
      <div class="features">
      <div class="team">
        <div class="row">
          <div class="col-md-4">
            <div class="team-player">
              <div class="card">
                <div class="col-md-6 ml-auto mr-auto">
                  <div class="cardIcons cardIcons1">
                    <i class="fab fa-leanpub fa-3x" aria-hidden="true" style="margin-top: 25px"></i>
                  </div>
                </div>
                <h4 class="card-title">e-Learning
                  <br>
                  <!--<small class="card-description text-muted">Model</small>-->
                </h4>
                <div class="card-body">
                  <p class="card-description">Make learning easier and smarter <br>for your students anytime, anywhere
                    <br>with our e-learning feature
                    <!--<a href="#">links</a> for people to be able to follow them outside the site.-->
                  </p>
                </div>
                <!--<div class="card-footer justify-content-center">
                  <a href="#pablo" class="btn btn-link btn-just-icon"><i class="fa fa-twitter"></i></a>
                  <a href="#pablo" class="btn btn-link btn-just-icon"><i class="fa fa-instagram"></i></a>
                  <a href="#pablo" class="btn btn-link btn-just-icon"><i class="fa fa-facebook-square"></i></a>
                </div>-->
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="team-player">
              <div class="card">
                <div class="col-md-6 ml-auto mr-auto">
                  <div class="cardIcons cardIcons2">
                    <!--<i class="fas fa-edit fa-3x" aria-hidden="true" style="margin-top: 25px"></i>-->
                    <i class="fa fa-pencil-square-o fa-3x" aria-hidden="true" style="margin-top: 25px"></i>
                  </div>
                </div>
                <h4 class="card-title">Results Collation
                  <br>
                  <!--<small class="card-description text-muted">Designer</small>-->
                </h4>
                <div class="card-body">
                  <p class="card-description">
                    With CollegeDreams, you can easily <br> collate the results of your <br>students
                    <!--<a href="#">links</a> for people to be able to follow them outside the site.-->
                  </p>
                </div>
                <!--<div class="card-footer justify-content-center">
                  <a href="#pablo" class="btn btn-link btn-just-icon"><i class="fa fa-twitter"></i></a>
                  <a href="#pablo" class="btn btn-link btn-just-icon"><i class="fa fa-linkedin"></i></a>
                </div>-->
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="team-player">
              <div class="card">
                <div class="col-md-6 ml-auto mr-auto">
                  <!--<img src="../../../assets/img/faces/kendall.jpg" alt="Thumbnail Image"
                       class="img-raised rounded-circle img-fluid">-->
                  <div class="cardIcons cardIcons3">
                    <i class="fa fa-envelope fa-3x" aria-hidden="true" style="margin-top: 25px"></i>
                  </div>
                </div>
                <h4 class="card-title">Email Notification
                  <br>
                  <!--<small class="card-description text-muted">Model</small>-->
                </h4>
                <div class="card-body">
                  <p class="card-description">
                    Send e-mail notifications and Bulk <br>SMS to parents
                    <!--<a href="#">links</a> for people to be able to follow them outside the site.-->
                  </p>
                </div>
                <!--<div class="card-footer justify-content-center">
                  <a href="#pablo" class="btn btn-link btn-just-icon"><i class="fa fa-twitter"></i></a>
                  <a href="#pablo" class="btn btn-link btn-just-icon"><i class="fa fa-instagram"></i></a>
                  <a href="#pablo" class="btn btn-link btn-just-icon"><i class="fa fa-facebook-square"></i></a>
                </div>-->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
  <div class="yellowBar"></div>
  <div class="section-result-checker">
    <img src="../../../assets/img/08stud.png" class="resultChecks" alt="Thumbnail Image">
    <div class="result-checker">
      <h2 class="infoh"> Online Admissions </h2>
      <p class="infop">
        Apply to any school of your choice via our online admission application <br>
        portal. Click on the button below to get started.
      </p>
      <a class="startNow mt-2" [routerLink]="['/online-admissions']">
        Apply Now
      </a>
    </div>
  </div>
  <div class="blueBar mb-2"></div>
  <!--<div class="section-partner">
    <div class="">
      <h2 class="title text-center">Our Partners</h2>
      <div class="row">
        <div class="col-md-4">
          <div class="">
            <a href="https://www.nibss-plc.com.ng/" target="_blank">
              <img src="../../../assets/img/nibss.png" alt="nibss picture" width="400" style="margin-top: -44px;">
            </a>
          </div>
        </div>
        <div class="col-md-4">
          <div class="">
            <a href="https://sterling.ng/" target="_blank">
              <img src="../../../assets/img/sterling.png" alt="sterling bank picture" width="350">
            </a>
          </div>
        </div>
        <div class="col-md-4">
          <div class="">
            <a href="https://flutterwave.com/ng/" target="_blank">
              <img src="../../../assets/img/flutterwave.png" alt="flutterwave picture" width="350">
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>-->
  <app-review-page></app-review-page>

  <div class="our-partners">
    <h3 class="title text-center">Our Partners</h3>
    <div class="partners">
      <div class="diffPartners">
      <a href="https://www.nibss-plc.com.ng/" target="_blank">
        <img src="../../../assets/img/nibss.png" alt="nibss picture" style="object-fit: cover">
      </a>
    </div>
      <div class="diffPartners">
        <a href="https://sterling.ng/" target="_blank">
          <img src="../../../assets/img/sterling.png" alt="sterling bank picture" style="object-fit: cover">
        </a>
      </div>
      <div class="diffPartners">
        <a href="https://flutterwave.com/ng/" target="_blank">
          <img src="../../../assets/img/flutterwave.png" alt="flutterwave picture" width="400">
        </a>
      </div>
    </div>
  </div>

  <!-- Boxes Section -->
  <div class="section newsletter section-contact-us">
    <div class="box box1">
      <h3>
        <span>College</span>Dreams
      </h3>
      <p style="font-size: 17px;">
        A modern school management software <br> designed to eliminate rigorous work,
        so you <br> can focus on the things that matter
      </p>
    </div>
    <div class="box box2">
      <h3>Office Address</h3>
      <div class="block-23 mb-1">
        <ul>
          <li class="mb-2">
            <span class="fa fa-map-marker fa-2x"></span>
            <span class="text">
            15B, Husseini Sommunu Street Ikorodu, Lagos State
          </span>
          </li>
          <li>
            <span class="fa fa-volume-control-phone fa-2x"></span>
            <span class="text">
              080 222 334 89
            </span>
          </li>
        </ul>
      </div>
    </div>
    <div class="box box3">
      <!--<i class="fas fa-cog fa-3x"></i>-->
      <h3>Newsletter</h3>
      <div id="mc_embed_signup">
        <form novalidate #subscribeForm="ngForm" (ngSubmit)="subscribeProcess()">
          <input type="email" name="email" id="newsletter-form-email"
                 placeholder="   Email Address"
                 #email="ngModel"
                 [(ngModel)]="credentials.email"
                 [ngModelOptions]="{standalone: true}"
                 class="placeholder hide-on-focus" onfocus="this.placeholder = ''"
                 onblur="this.placeholder = ' Email Address '">
          <button type="submit" name="submit" id="newsletter-submit"
                  class="email_icon newsletter-submit button-contactForm">
            <i class="fa fa-paper-plane" aria-hidden="true"></i>
            <i class="fa fa-spinner fa-spin" *ngIf="loading"></i>
          </button>
        </form>
      </div>
      <div class="follow">
        <h4> Follow Us</h4>
        <a href="#pablo" class="btn btn-link btn-just-icon fb">
          <i class="fab fa-facebook-f"></i>
        </a>
        <a href="#pablo" class="btn btn-link btn-just-icon twit">
          <i class="fab fa-twitter"></i>
        </a>
        <a href="#pablo" class="btn btn-link btn-just-icon ig">
          <i class="fab fa-instagram"></i>
        </a>
      </div>
    </div>
  </div>
    <!--End Boxes Section -->
  </div>
<footer class="footer footer-default">
  <div class="container">
    <div class="row">
      <div class="mouse">
        <a (click)="scrollToTop()" class="mouse-icon" *ngIf="pageYoffset > 0">
          <div class="mouse-wheel">
            <span class="fa fa-chevron-up" style="color: #ffffff"></span>
          </div>
        </a>
      </div>
    </div>
    <div class="float-left">
      &copy;{{ year }}, CollegeDreams | All rights reserved
    </div>
  </div>
</footer>
